import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { IDatepickerEvents, IDatepickerFields } from '../../components/Datepicker/types';
import { Datepicker } from '../../components/Datepicker/Datepicker';
import { getUserDateFormat } from '../../../../../../../store/model/authUser/selectors/getUserDateFormat';
import { getUserTimeFormat12 } from '../../../../../../../store/model/authUser/selectors/getUserTimeFormat12';
import {
    getUserCalendarStartsSunday
} from '../../../../../../../store/model/authUser/selectors/getUserCalendarStartsSunday';
import { isEqual } from 'underscore';
import { IDatepickerHOCProps } from './types';
import { onShowSnackbar } from './selectors/onShowSnackbar';
import { onDoubleClick } from './events/onDoubleClick';

const mapStateToProps = () => {
    interface ICaheProps extends IDatepickerFields{};
    let cache: ICaheProps = null;
    const getCache = (
        value: ICaheProps
    ): ICaheProps => {
        if (isEqual(value, cache)) return cache;
        cache = value; return value;
    };

    return (
        state: IApplicationState,
        ownProps: IDatepickerHOCProps,
    ): IDatepickerFields => {
        return getCache({
            ...ownProps,
            dateFormat: getUserDateFormat(state),
            isCalendarStartsSunday: getUserCalendarStartsSunday(state),
            is12Hour: getUserTimeFormat12(state)
        });
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IDatepickerHOCProps,
): IDatepickerEvents => {
    return {
        ...ownProps,
        onDoubleClick: (source) => dispatch(onDoubleClick(source)),
        onShowSnackbar: () => dispatch(onShowSnackbar()),
    };
};

export const DatepickerHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Datepicker);

DatepickerHOC.displayName = 'DatepickerHOC';
